import React from 'react';

export interface EducationProps {}

const Education: React.FC<EducationProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Education</h1>
            <h3>& Certification</h3>
            <br />
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h2>B.A. (Program)</h2>
                        <b>
                            <p>2012 - 2015</p>
                        </b>
                    </div>
                    <h3>Miranda House, University of Delhi</h3>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Ranked India's #1 college in the Government of India's NIRF
                    rankings, 2017–2023.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h2>Bachelor of Education (B.Ed)</h2>
                        <b>
                            <p>2019 - 2021</p>
                        </b>
                    </div>
                    <h3>Chaudhary Charan Singh University, Meerut</h3>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Raizada Dharam Das Institute of Education & Technology.
                    Pedagogy, assessment, child development and supervised
                    school teaching practice.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h2>Central Teacher Eligibility Test (CTET)</h2>
                        <b>
                            <p>Dec 2021</p>
                        </b>
                    </div>
                    <h3>Paper I & II, CBSE</h3>
                </div>
            </div>
            <div className="text-block">
                <p>
                    India's national teacher-eligibility certification for
                    Classes 1–8; valid for life.
                </p>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h2>Class XII, Humanities</h2>
                        <b>
                            <p>2012</p>
                        </b>
                    </div>
                    <h3>Kendriya Vidyalaya ASC Centre, Bengaluru</h3>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Ranked 2nd in Humanities across the Kendriya Vidyalaya
                    Bengaluru Region.
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
};

export default Education;
